export const OVERVIEW = 'Overview';
export const RETIREMENT_INCOME = 'Retirement Income';
export const MONTE_CARLO = 'Monte Carlo';
export const ROTH_CONVERSION = 'Roth Conversion';
export const ASSUMPTIONS = 'Assumptions';

export const RETIREMENT_GOAL_TYPE = 'retirement';

export const GOAL_CHART_MAP = {
  [OVERVIEW]: 'Retirement Assets',
  [RETIREMENT_INCOME]: 'Retirement Income',
  [MONTE_CARLO]: 'Monte Carlo',
  [ROTH_CONVERSION]: 'Roth Conversion',
};

export const ASSUMPTIONS_TITLE = 'Below are the assumptions made for this plan';
